import { render, staticRenderFns } from "./MasterCreatedGroupClassDetails.vue?vue&type=template&id=ef62da6e"
import script from "./MasterCreatedGroupClassDetails.vue?vue&type=script&lang=js"
export * from "./MasterCreatedGroupClassDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports